import { render, staticRenderFns } from "./ProductVariantConfigs.vue?vue&type=template&id=07197e44&scoped=true"
import script from "./ProductVariantConfigs.vue?vue&type=script&lang=js"
export * from "./ProductVariantConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07197e44",
  null
  
)

export default component.exports